// extracted by mini-css-extract-plugin
export default {"services":"Services_services__+n3JG","servicesTxt":"Services_servicesTxt__Q3QHl","blocs":"Services_blocs__eBoPQ"};